
import lodash from 'lodash';

import apiRequest from '../../../utils/api.request';
import config from '../../../config.json';
import {vaccinationApiRequestBody} from '../../VaccinationDetails/VaccinationDetailsWrapper/Utils/vaccinationApiRequestBody';

const isJhhIdVerifiedUrl = config.covid_vacc_base_url + "v1/get-jhh-for-eoi/";

export const isJhhIdVerified = async (userParams) => {
  const requestData = vaccinationApiRequestBody({}, userParams);
  const response = await apiRequest(isJhhIdVerifiedUrl, requestData, true);
  if(response.apiResponse == "failed"){
    throw new Error(lodash.get(response, "response.data.message", "Something went wrong, please try again"));
  }
  return response;
}